<template>
  <div>
    <el-dialog
      :title="isDetailPopup ? 'Chi tiết giao dịch' : 'Sửa giao dịch'"
      :visible.sync="modifyTransactionDialog"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="das-info-title">Thông tin giao dịch</div>
      <InfoList :columns="3">
        <InfoListLabel>Tên khách</InfoListLabel>
        <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

        <InfoListLabel>Ngày GD</InfoListLabel>
        <InfoListValue>{{ transactions[0]?.trans_date || null }}</InfoListValue>

        <InfoListLabel>Tham chiếu</InfoListLabel>
        <InfoListValue>{{
          transactions[0]?.invoice_num || null
        }}</InfoListValue>

        <InfoListLabel>Trang giao dịch</InfoListLabel>
        <InfoListValue>{{ selectedTab?.label || null || null }}</InfoListValue>

        <InfoListLabel>Giao dịch chính</InfoListLabel>
        <InfoListValue>{{
          transactions[0]?.sub_transaction_id || null
        }}</InfoListValue>

        <InfoListLabel>Giao dịch phụ</InfoListLabel>
        <InfoListValue>{{
          transactions[0]?.sub_transaction_desc || null
        }}</InfoListValue>

        <InfoListLabel>Phần trăm phí</InfoListLabel>
        <InfoListValue>{{ transactions[0]?.fee || 0 }}%</InfoListValue>

        <InfoListLabel>Phần trăm thuế</InfoListLabel>
        <InfoListValue>{{ transactions[0]?.tax || 0 }}%</InfoListValue>

        <!-- <InfoListLabel>Giá trước thuế</InfoListLabel>
          <InfoListValue><CurrencyInput /></InfoListValue>

          <InfoListLabel>Giá sau thuế</InfoListLabel>
          <InfoListValue><CurrencyInput /></InfoListValue> -->
      </InfoList>
      <div class="das-form-container relative">
        <div v-if="isDetailPopup" class="transparent-overlay" />
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Số tiền trước thuế">
                  <div class="das-form-input">
                    <div class="label required">Số tiền trước thuế(VND)</div>
                    <VxCurrencyInput
                      v-model="editTransactionForm.moneyBeforeTax"
                      @blur="transactionMoneyBeforeChanged"
                    />
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Số tiền sau thuế">
                  <div class="das-form-input">
                    <div class="label required">Số tiền sau thuế(VND)</div>
                    <VxCurrencyInput
                      v-model="editTransactionForm.money"
                      @blur="transactionMoneyAfterChanged"
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max:200" name="Ghi chú">
                  <div class="das-form-input">
                    <div class="label required">Ghi chú</div>
                    <textarea v-model="editTransactionForm.note" :rows="2" />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="modifyTransactionDialog = false"
          >
            Đóng
          </button>
          <button
            v-if="!isDetailPopup"
            class="btn primary small"
            @click="submitEditTransaction"
          >
            Cập nhật
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { submitEditTransactionApi } from '@/api/cashier_service/postTransaction'
export default {
  components: {},
  props: {
    isDetailPopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modifyTransactionDialog: false,
      editTransactionForm: {
        money: null,
        moneyBeforeTax: null,
        note: null
      }
    }
  },
  computed: {
    bookingInfo() {
      return this.$store.getters['cashier']
    },
    selectedTab() {
      return this.$store.getters['selectedTab']
    },
    transactions() {
      return this.$store.getters['transactions']
    }
  },
  watch: {
    modifyTransactionDialog() {
      this.modifyTransactionDialog ? null : this.resetDialog()
    }
  },
  methods: {
    resetDialog() {
      this.$nullValueInObj(this.editTransactionForm)
      this.$emit('resetDialog')
    },
    buildInitData() {
      Object.assign(this.editTransactionForm, this.transactions[0])
      this.editTransactionForm.trans_page = this.selectedTab?.value || null
      // const tax = this.editTransactionForm.tax
      // const fee = this.editTransactionForm.fee
      const mn = this.editTransactionForm.money
      const mn1 =
        mn /
        (1 +
          (this.editTransactionForm.tax + this.editTransactionForm.fee) * 0.01)
      this.editTransactionForm.moneyBeforeTax = mn1
    },
    transactionMoneyBeforeChanged() {
      const value = this.editTransactionForm.moneyBeforeTax
      const tax = this.editTransactionForm.tax
      const fee = this.editTransactionForm.fee
      this.editTransactionForm.money =
        value + tax * value * 0.01 + fee * value * 0.01
    },
    transactionMoneyAfterChanged() {
      const value = this.editTransactionForm.money
      const tax = this.editTransactionForm.tax
      const fee = this.editTransactionForm.fee
      this.editTransactionForm.moneyBeforeTax =
        value - tax * value * 0.01 - fee * value * 0.01
    },
    async submitEditTransaction() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      await submitEditTransactionApi(
        this.transactions[0].id,
        this.editTransactionForm
      )
        .then(async res => {
          const message = res.message
          this.$store.dispatch('cashier/changeTransactionListIndex')
          this.modifyTransactionDialog = false
          this.$emit('submitDone')
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    }
  }
}
</script>
